// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AssetIntegration_EntityFragment } from '../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
import { EntityActionsMenu_EntityFragment } from '../../entities/components/EntityActionsMenu/EntityActionsMenu.generated';
import { StructuredAssetsSubform_AccountFragment } from '../../entities/StructuredAssetsSubform/graphql/StructuredAssetsSubform.generated';
import { InsurancePolicies_InsurancePolicyFragment } from '../../entities/InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import { GetTaxStatusForEntity_EntityFragment } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import { LiabilitiesTable_LiabilityFragment } from '../../liabilities/LiabilitiesTable/graphql/LiabilitiesTable.generated';
import { gql } from '@apollo/client';
import { AssetIntegration_EntityFragmentDoc } from '../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
import { EntityActionsMenu_EntityFragmentDoc } from '../../entities/components/EntityActionsMenu/EntityActionsMenu.generated';
import { StructuredAssetsSubform_AccountFragmentDoc } from '../../entities/StructuredAssetsSubform/graphql/StructuredAssetsSubform.generated';
import { InsurancePolicies_InsurancePolicyFragmentDoc } from '../../entities/InsurancePolicyDetailsSubform/graphql/InsurancePolicies.generated';
import { GetTaxStatusForEntity_EntityFragmentDoc } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import { LiabilitiesTable_LiabilityFragmentDoc } from '../../liabilities/LiabilitiesTable/graphql/LiabilitiesTable.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstatePage_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, firstName: string, lastName: string, displayName: string, isPrimary: boolean };

export type EstatePage_PrincipalFragment = { __typename?: 'Principal', id: string, individual?: (
    { __typename?: 'ClientProfile' }
    & EstatePage_ClientProfileFragment
  ) | null };

export type EstatePage_EntityFragment = (
  { __typename?: 'Entity', id: string, kind: Types.EntityKind, liquidityStatus: Types.EntityLiquidityStatus, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CLTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'CustodialPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, owner?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'DonorAdvisedFund', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, donors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'GPBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'GRATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, assetSummaryDisplay?: string | null, currentValue: CurrencyUSD, displayName: string, grantor?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'ILITTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'IndividualPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, owner?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'InsurancePersonalAccount', currentValue: CurrencyUSD, id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, assetSummaryDisplay?: string | null, beneficiaryDesignationsReviewedAt?: Time | null, displayName: string, owners?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, beneficiaryDesignations: { __typename?: 'BeneficiaryDesignations', primary?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null, contingent?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null }, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'IrrevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'JointPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, owners?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'LLCBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'LPBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'PrivateFoundation', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, donors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'QPRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, owner?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'RetirementPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, beneficiaryDesignationsReviewedAt?: Time | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, beneficiaryDesignations: { __typename?: 'BeneficiaryDesignations', primary?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null, contingent?: { __typename?: 'BeneficiaryDesignationGroup', id: string, dispositiveProvisions: { __typename?: 'DispositiveProvisionConnection', totalCount: number } } | null }, owner?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'RevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    )> | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SCorpBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SLATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, stateInEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, assetSummaryDisplay?: string | null, displayName: string, grantor?: (
      { __typename?: 'Principal' }
      & EstatePage_PrincipalFragment
    ) | null, policies?: Array<(
      { __typename?: 'InsurancePolicy' }
      & InsurancePolicies_InsurancePolicyFragment
    )> | null, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, taxStatus?: Types.BusinessEntityTaxStatus | null, formationJurisdictionStateCode?: string | null, displayName: string, currentValue: CurrencyUSD, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null, designerAccount?: (
      { __typename?: 'Account' }
      & StructuredAssetsSubform_AccountFragment
    ) | null }, ownedByStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownershipPercentage?: Percent | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string, dispositionScenarios?: Array<{ __typename?: 'DispositionScenario', id: string, reviewedAt?: Time | null }> | null } | null, owningEntity?: (
      { __typename?: 'Entity', id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }
      & GetTaxStatusForEntity_EntityFragment
    ) | null }> | null, onboardingEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, ownedOwnershipStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownedValue: CurrencyUSD, ownershipPercentage?: Percent | null, ownedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, kind: Types.IntegrationEntityKind, name: string }> | null } | null }> | null, liabilitiesOwed: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability' }
        & LiabilitiesTable_LiabilityFragment
      ) | null } | null> | null }, liabilitiesLent: { __typename?: 'LiabilityConnection', edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability' }
        & LiabilitiesTable_LiabilityFragment
      ) | null } | null> | null } }
  & AssetIntegration_EntityFragment
  & EntityActionsMenu_EntityFragment
);

export type EstatePage_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus?: Types.EntityInEstateStatus | null, kind: Types.TestamentaryEntityKind, onboardingTestamentaryEntitySuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export type EstatePage_UnacknowledgedAiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, dpFirstDeathGrantorClientProfile?: { __typename?: 'ClientProfile', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null };

export type EstatePage_UnacknowledgedHoldingSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, entity?: { __typename?: 'Entity', id: string } | null, asset?: { __typename?: 'AssetSuggestion', assetCategoryID?: string | null, assetTitle?: string | null, assetValue?: string | null } | null, liability?: { __typename?: 'LiabilitySuggestion', asOfDate?: string | null, debtorEntityID?: string | null, debtorEntityName?: string | null, lenderEntityID?: string | null, lenderEntityName?: string | null, liabilityName?: string | null, outstandingBalance?: string | null } | null, lifeInsurance?: { __typename?: 'LifeInsuranceSuggestion', cashValueAmount?: string | null, deathBenefitAmount?: string | null, insuranceCarrier?: string | null, policyType?: Types.InsurancePolicyKind | null, termLengthYears?: number | null, insuredClientProfiles?: Array<{ __typename?: 'InsuredClientProfileSuggestion', clientProfileID?: string | null }> | null } | null, sourceKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: { __typename?: 'KGV2Node', id: string } | null } | null> | null }, kgV2Statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: { __typename?: 'KGV2Statement', id: string, predicate: string, subject: { __typename?: 'KGV2Node', id: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string } | null } | null> | null } } } | null } | null> | null } };

export type EstatePageDataQueryVariables = Types.Exact<{
  entitiesLike: Types.EntityWhereInput;
  householdId: Types.Scalars['ID']['input'];
  detailSuggestionsWhere: Types.AiSuggestionWhereInput;
  holdingSuggestionsWhere: Types.AiSuggestionWhereInput;
  includeDraftEntities: Types.Scalars['Boolean']['input'];
  includeTestamentaryEntities: Types.Scalars['Boolean']['input'];
}>;


export type EstatePageDataQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity', id: string }
        & EstatePage_EntityFragment
      ) | null } | null> | null }, testamentaryEntities?: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & EstatePage_TestamentaryEntityFragment
      ) | null } | null> | null }, draftEntities?: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity', id: string }
        & EstatePage_EntityFragment
      ) | null } | null> | null }, aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & EstatePage_UnacknowledgedAiSuggestionFragment
      ) | null } | null> | null }, holdingSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & EstatePage_UnacknowledgedHoldingSuggestionFragment
      ) | null } | null> | null } };

export type EstatePageEntityQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type EstatePageEntityQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EstatePage_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EstatePageData: 'EstatePageData' as const,
    EstatePageEntity: 'EstatePageEntity' as const
  },
  Fragment: {
    EstatePage_ClientProfile: 'EstatePage_ClientProfile' as const,
    EstatePage_Principal: 'EstatePage_Principal' as const,
    EstatePage_Entity: 'EstatePage_Entity' as const,
    EstatePage_TestamentaryEntity: 'EstatePage_TestamentaryEntity' as const,
    EstatePage_UnacknowledgedAISuggestion: 'EstatePage_UnacknowledgedAISuggestion' as const,
    EstatePage_UnacknowledgedHoldingSuggestion: 'EstatePage_UnacknowledgedHoldingSuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstatePage_ClientProfileFragmentDoc = gql`
    fragment EstatePage_ClientProfile on ClientProfile {
  id
  firstName
  lastName
  displayName
  isPrimary
}
    `;
export const EstatePage_PrincipalFragmentDoc = gql`
    fragment EstatePage_Principal on Principal {
  id
  individual {
    ...EstatePage_ClientProfile
  }
}
    ${EstatePage_ClientProfileFragmentDoc}`;
export const EstatePage_EntityFragmentDoc = gql`
    fragment EstatePage_Entity on Entity {
  id
  kind
  liquidityStatus
  stage
  ...AssetIntegration_Entity
  ...EntityActionsMenu_Entity
  subtype {
    id
    displayName
    currentValue
    dispositionScenarios {
      id
      reviewedAt
    }
    designerAccount {
      ...StructuredAssetsSubform_Account
    }
    ... on IndividualPersonalAccount {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      owner {
        ...EstatePage_Principal
      }
    }
    ... on GRATTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      assetSummaryDisplay
      currentValue
      grantor {
        ...EstatePage_Principal
      }
    }
    ... on ILITTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on RevocableTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on SLATTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantor {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on IrrevocableTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on QPRTTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
    }
    ... on CRTTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on CLTTrust {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      grantors {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on BusinessEntity {
      id
      assetSummaryDisplay
      grantorControlledValue
      taxStatus
      formationJurisdictionStateCode
      ... on CCorpBusinessEntity {
        policies {
          ...InsurancePolicies_InsurancePolicy
        }
      }
      ... on SCorpBusinessEntity {
        policies {
          ...InsurancePolicies_InsurancePolicy
        }
      }
      ... on GPBusinessEntity {
        policies {
          ...InsurancePolicies_InsurancePolicy
        }
      }
      ... on LPBusinessEntity {
        policies {
          ...InsurancePolicies_InsurancePolicy
        }
      }
      ... on LLCBusinessEntity {
        policies {
          ...InsurancePolicies_InsurancePolicy
        }
      }
    }
    ... on InsurancePersonalAccount {
      currentValue
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      owners {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on JointPersonalAccount {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      owners {
        ...EstatePage_Principal
      }
    }
    ... on RetirementPersonalAccount {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      beneficiaryDesignationsReviewedAt
      beneficiaryDesignations(hypotheticalWaterfallId: null) {
        primary {
          id
          dispositiveProvisions {
            totalCount
          }
        }
        contingent {
          id
          dispositiveProvisions {
            totalCount
          }
        }
      }
      owner {
        ...EstatePage_Principal
      }
    }
    ... on CustodialPersonalAccount {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      owner {
        ...EstatePage_Principal
      }
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      owner {
        ...EstatePage_Principal
      }
    }
    ... on InsurancePersonalAccount {
      id
      assetSummaryDisplay
      currentValue
      gstStatus
      inEstateStatus
      stateInEstateStatus
      beneficiaryDesignationsReviewedAt
      beneficiaryDesignations(hypotheticalWaterfallId: null) {
        primary {
          id
          dispositiveProvisions {
            totalCount
          }
        }
        contingent {
          id
          dispositiveProvisions {
            totalCount
          }
        }
      }
      owners {
        ...EstatePage_Principal
      }
      policies {
        ...InsurancePolicies_InsurancePolicy
      }
    }
    ... on DonorAdvisedFund {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      donors {
        ...EstatePage_Principal
      }
    }
    ... on PrivateFoundation {
      id
      inEstateStatus
      stateInEstateStatus
      gstStatus
      currentValue
      assetSummaryDisplay
      donors {
        ...EstatePage_Principal
      }
    }
  }
  ownedByStakes {
    id
    ownershipPercentage
    owningIndividual {
      id
      displayName
      dispositionScenarios {
        id
        reviewedAt
      }
    }
    owningEntity {
      id
      entityKind: kind
      extendedDisplayKind
      subtype {
        id
        displayName
      }
      ...GetTaxStatusForEntity_Entity
    }
  }
  onboardingEntitySuggestion {
    id
  }
  ownedOwnershipStakes {
    id
    ownedValue
    ownershipPercentage
    ownedEntity {
      id
      subtype {
        id
        displayName
      }
      integrationEntities {
        id
        kind
        name
      }
    }
  }
  liabilitiesOwed {
    edges {
      node {
        ...LiabilitiesTable_Liability
      }
    }
  }
  liabilitiesLent {
    edges {
      node {
        ...LiabilitiesTable_Liability
      }
    }
  }
}
    ${AssetIntegration_EntityFragmentDoc}
${EntityActionsMenu_EntityFragmentDoc}
${StructuredAssetsSubform_AccountFragmentDoc}
${EstatePage_PrincipalFragmentDoc}
${InsurancePolicies_InsurancePolicyFragmentDoc}
${GetTaxStatusForEntity_EntityFragmentDoc}
${LiabilitiesTable_LiabilityFragmentDoc}`;
export const EstatePage_TestamentaryEntityFragmentDoc = gql`
    fragment EstatePage_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
  gstStatus
  inEstateStatus
  kind
  onboardingTestamentaryEntitySuggestion {
    id
  }
  createdFromEntities {
    edges {
      node {
        id
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;
export const EstatePage_UnacknowledgedAiSuggestionFragmentDoc = gql`
    fragment EstatePage_UnacknowledgedAISuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  dpFirstDeathGrantorClientProfile {
    id
  }
  entity {
    id
  }
  testamentaryEntity {
    id
  }
}
    `;
export const EstatePage_UnacknowledgedHoldingSuggestionFragmentDoc = gql`
    fragment EstatePage_UnacknowledgedHoldingSuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  entity {
    id
  }
  asset {
    assetCategoryID
    assetTitle
    assetValue
  }
  liability {
    asOfDate
    debtorEntityID
    debtorEntityName
    lenderEntityID
    lenderEntityName
    liabilityName
    outstandingBalance
  }
  lifeInsurance {
    cashValueAmount
    deathBenefitAmount
    insuranceCarrier
    insuredClientProfiles {
      clientProfileID
    }
    policyType
    termLengthYears
  }
  sourceKgV2Nodes(first: 1) {
    edges {
      node {
        id
      }
    }
  }
  kgV2Statements(where: {predicate: "is_creditor_of"}) {
    edges {
      node {
        id
        predicate
        subject {
          id
          resolvedEntities {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const EstatePageDataDocument = gql`
    query EstatePageData($entitiesLike: EntityWhereInput!, $householdId: ID!, $detailSuggestionsWhere: AISuggestionWhereInput!, $holdingSuggestionsWhere: AISuggestionWhereInput!, $includeDraftEntities: Boolean!, $includeTestamentaryEntities: Boolean!) {
  entities(where: $entitiesLike) {
    edges {
      node {
        id
        ...EstatePage_Entity
      }
    }
  }
  testamentaryEntities(where: {householdID: $householdId}) @include(if: $includeTestamentaryEntities) {
    edges {
      node {
        ...EstatePage_TestamentaryEntity
      }
    }
  }
  draftEntities: entities(
    where: {stageIn: [DRAFT, IMPLEMENTATION, READY_FOR_PROPOSAL], hasHouseholdWith: [{id: $householdId}]}
  ) @include(if: $includeDraftEntities) {
    edges {
      node {
        id
        ...EstatePage_Entity
      }
    }
  }
  aiSuggestions(where: $detailSuggestionsWhere) {
    edges {
      node {
        ...EstatePage_UnacknowledgedAISuggestion
      }
    }
  }
  holdingSuggestions: aiSuggestions(where: $holdingSuggestionsWhere) {
    edges {
      node {
        ...EstatePage_UnacknowledgedHoldingSuggestion
      }
    }
  }
}
    ${EstatePage_EntityFragmentDoc}
${EstatePage_TestamentaryEntityFragmentDoc}
${EstatePage_UnacknowledgedAiSuggestionFragmentDoc}
${EstatePage_UnacknowledgedHoldingSuggestionFragmentDoc}`;

/**
 * __useEstatePageDataQuery__
 *
 * To run a query within a React component, call `useEstatePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstatePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstatePageDataQuery({
 *   variables: {
 *      entitiesLike: // value for 'entitiesLike'
 *      householdId: // value for 'householdId'
 *      detailSuggestionsWhere: // value for 'detailSuggestionsWhere'
 *      holdingSuggestionsWhere: // value for 'holdingSuggestionsWhere'
 *      includeDraftEntities: // value for 'includeDraftEntities'
 *      includeTestamentaryEntities: // value for 'includeTestamentaryEntities'
 *   },
 * });
 */
export function useEstatePageDataQuery(baseOptions: Apollo.QueryHookOptions<EstatePageDataQuery, EstatePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstatePageDataQuery, EstatePageDataQueryVariables>(EstatePageDataDocument, withFetchPolicyContext(options));
      }
export function useEstatePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstatePageDataQuery, EstatePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstatePageDataQuery, EstatePageDataQueryVariables>(EstatePageDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstatePageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstatePageDataQuery, EstatePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstatePageDataQuery, EstatePageDataQueryVariables>(EstatePageDataDocument, withFetchPolicyContext(options));
        }
export type EstatePageDataQueryHookResult = ReturnType<typeof useEstatePageDataQuery>;
export type EstatePageDataLazyQueryHookResult = ReturnType<typeof useEstatePageDataLazyQuery>;
export type EstatePageDataSuspenseQueryHookResult = ReturnType<typeof useEstatePageDataSuspenseQuery>;
export type EstatePageDataQueryResult = Apollo.QueryResult<EstatePageDataQuery, EstatePageDataQueryVariables>;
export const EstatePageEntityDocument = gql`
    query EstatePageEntity($entityId: ID!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        ...EstatePage_Entity
      }
    }
  }
}
    ${EstatePage_EntityFragmentDoc}`;

/**
 * __useEstatePageEntityQuery__
 *
 * To run a query within a React component, call `useEstatePageEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstatePageEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstatePageEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEstatePageEntityQuery(baseOptions: Apollo.QueryHookOptions<EstatePageEntityQuery, EstatePageEntityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstatePageEntityQuery, EstatePageEntityQueryVariables>(EstatePageEntityDocument, withFetchPolicyContext(options));
      }
export function useEstatePageEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstatePageEntityQuery, EstatePageEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstatePageEntityQuery, EstatePageEntityQueryVariables>(EstatePageEntityDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstatePageEntitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstatePageEntityQuery, EstatePageEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstatePageEntityQuery, EstatePageEntityQueryVariables>(EstatePageEntityDocument, withFetchPolicyContext(options));
        }
export type EstatePageEntityQueryHookResult = ReturnType<typeof useEstatePageEntityQuery>;
export type EstatePageEntityLazyQueryHookResult = ReturnType<typeof useEstatePageEntityLazyQuery>;
export type EstatePageEntitySuspenseQueryHookResult = ReturnType<typeof useEstatePageEntitySuspenseQuery>;
export type EstatePageEntityQueryResult = Apollo.QueryResult<EstatePageEntityQuery, EstatePageEntityQueryVariables>;